/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my data sent anywhere?`)
};

const es_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se envían mis datos a algún lugar?`)
};

const de_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden meine Daten irgendwohin gesendet?`)
};

const nl_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden mijn gegevens ergens heen verzonden?`)
};

const fr_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes données sont-elles envoyées quelque part ?`)
};

const it_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei dati vengono inviati da qualche parte?`)
};

const pt_br2_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meus dados são enviados para algum lugar?`)
};

const pt_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os meus dados são enviados para algum lado?`)
};

const ja_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私のデータはどこかに送られますか?`)
};

const zh_uc_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq2_q", locale)
	if (locale === "en") return en_uc_hub_faq2_q(inputs)
	if (locale === "es") return es_uc_hub_faq2_q(inputs)
	if (locale === "de") return de_uc_hub_faq2_q(inputs)
	if (locale === "nl") return nl_uc_hub_faq2_q(inputs)
	if (locale === "fr") return fr_uc_hub_faq2_q(inputs)
	if (locale === "it") return it_uc_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq2_q(inputs)
	if (locale === "pt") return pt_uc_hub_faq2_q(inputs)
	if (locale === "ja") return ja_uc_hub_faq2_q(inputs)
	return zh_uc_hub_faq2_q(inputs)
};